import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useEphemeralStore } from '@/lib/app-store';
import { useEffect } from 'react';
import { refreshPortalAggregatesCacheOptions } from '@/lib/queries';
import { usePortalContext } from '@/lib/use-portal-context';
import { waitForConfirmedDonationFn } from '@/lib/server-functions';

export function UpdatePortalOnConfirmedDonationFlow() {
	const { portalId } = usePortalContext();
	const queryClient = useQueryClient();
	const donationToConfirm = useEphemeralStore((store) => store.donationToConfirm);
	const setDonationToConfirm = useEphemeralStore((store) => store.setDonationToConfirm);
	const donationConfirmed = useEphemeralStore((store) => store.donationConfirmed);
	const setDonationConfirmed = useEphemeralStore((store) => store.setDonationConfirmed);
	const { mutateAsync: refreshAggregatesCache } = useMutation(refreshPortalAggregatesCacheOptions());

	useEffect(() => {
		if (!donationToConfirm) return;
		if (!portalId) return;

		const waitForConfirmedDonation = async () => {
			console.time('[WORLDCOO] Donation confirmed in');
			console.info('[WORLDCOO] Waiting for donation confirmation...');
			for await (const msg of await waitForConfirmedDonationFn({ data: donationToConfirm.id })) {
				if (msg === 'donation.confirmed') {
					console.time('[WORLDCOO] Waiting to refresh aggregates cache...');
					await refreshAggregatesCache({
						portalId: portalId,
					});
					console.timeEnd('[WORLDCOO] Waiting to refresh aggregates cache...');

					await queryClient.invalidateQueries({ queryKey: [portalId, 'campaigns-aggregates'] });

					console.info('[WORLDCOO] Aggregates refreshed');
					console.timeEnd('[WORLDCOO] Donation confirmed in');
					setDonationConfirmed(true);
				} else {
					console.warn('[WORLDCOO] Donation confirmation timed out');
				}
				setDonationToConfirm(undefined);
			}
		};

		waitForConfirmedDonation();
	}, [
		donationConfirmed,
		donationToConfirm,
		portalId,
		queryClient,
		refreshAggregatesCache,
		setDonationConfirmed,
		setDonationToConfirm,
	]);

	return null;
}
